import siteConfig from '@/mixins/siteConfig'
import authService, { USER_ROLES } from '@/api/authService'
import campaignsService from '@/api/campaignsService'
import userService from '@/api/userService'
import { mapState, mapMutations } from 'vuex'
import { MODULE_NAME, MUTATIONS } from '@/store/campaigns/constants'
import { MODULE_NAME as MODULE_NAME_FILTERS } from '@/store/filters/constants'

export default {
  name: 'Sidebar',
  mixins: [
    siteConfig
  ],
  components: {
    MenuButton: () => import(/* webpackChunkName: "MenuButton" */ './menu-button/MenuButton.vue')
  },
  props: {},
  data () {
    return {
      authData: authService.authData,
      expanded: false,
      users: {
        count: 0
      }
    }
  },
  mounted () {
    this.$el.addEventListener('mouseover', this.open, false)
    this.$el.addEventListener('mouseleave', this.close, false)
    campaignsService.getCampaigns({ page_size: 1 }, this.filters)
      .then(data => {
        this[MUTATIONS.SET_META](data.meta)
      })
    if (
      this.authData.user.role === USER_ROLES.CENTRAL_ADMIN ||
      this.authData.user.role === USER_ROLES.ROOT
    ) {
      userService.getUsers({ page_size: 1 })
        .then(data => {
          this.users.count = data.meta.count || 0
        })
    }
  },
  computed: {
    ...mapState(MODULE_NAME, ['meta']),
    ...mapState(MODULE_NAME_FILTERS, ['filters']),
    isAdmin () {
      return this.authData.user.role === USER_ROLES.CENTRAL_ADMIN ||
        this.authData.user.role === USER_ROLES.ROOT
    },
    isExteriorAgency () {
      return this.authData.user.role === USER_ROLES.AGENCY_EXTERIOR
    },
    isPatrimony () {
      return this.authData.user.role === USER_ROLES.AGENCY_PATRIMONY
    },
    currentYear () {
      return new Date().getFullYear()
    }
  },
  methods: {
    ...mapMutations(MODULE_NAME, [ MUTATIONS.SET_META ]),
    open () {
      this.expanded = true
    },
    close () {
      this.expanded = false
    },
    logout () {
      authService.logout(false)
    }
  }
}
